import styled from "styled-components";

export const HomeContainer = styled.main`
  position: relative;
  z-index: 1;
  min-height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-8) var(--space-4);
`;

export const Hero = styled.div`
  width: 100%;
  max-width: 28rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-6);
  text-align: center;
`;

export const Tagline = styled.p`
  margin: 0;
  max-width: 22rem;
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--ink-soft);
  line-height: 1.5;
`;

export const CardFan = styled.div`
  position: relative;
  height: 128px;
  width: 200px;
  margin: var(--space-2) 0 calc(-1 * var(--space-2));
`;

export const FanCard = styled.div<{ $dark?: boolean; $tilt: number; $x: number }>`
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 92px;
  height: 124px;
  margin-left: -46px;
  padding: var(--space-2);
  border-radius: var(--radius-md);
  border: var(--border-w) solid ${({ $dark }) => ($dark ? "var(--night-lip)" : "var(--ink)")};
  background: ${({ $dark }) => ($dark ? "var(--night)" : "var(--card)")};
  color: ${({ $dark }) => ($dark ? "var(--night-ink)" : "var(--ink)")};
  box-shadow: 0 var(--lip) 0 ${({ $dark }) => ($dark ? "var(--night-lip)" : "var(--line-strong)")};
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 0.7rem;
  line-height: 1.25;
  text-align: left;
  transform-origin: 50% 110%;
  transform: translateX(${({ $x }) => $x}px) rotate(${({ $tilt }) => $tilt}deg);
  transition: transform var(--dur-base) var(--ease-bounce);

  &:nth-child(2) {
    animation: bob 2.4s ease-in-out infinite;
  }

  svg {
    position: absolute;
    right: var(--space-2);
    bottom: var(--space-2);
    opacity: 0.8;
  }

  @media (hover: hover) {
    ${CardFan}:hover & {
      transform: translateX(${({ $x }) => $x * 1.5}px) rotate(${({ $tilt }) => $tilt * 1.6}deg);
    }
  }
`;

export const Panel = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
  background: var(--card);
  border: var(--border-w) solid var(--ink);
  border-radius: var(--radius-xl);
  box-shadow: 0 6px 0 var(--ink), var(--shadow-float);
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  color: var(--ink-faint);
  font-size: var(--text-sm);
  font-weight: 700;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-top: var(--border-w) dashed var(--line-strong);
  }
`;

export const Footnote = styled.p`
  margin: 0;
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--ink-faint);
`;
